import React from 'react';
import './style.scss';

import ResultItem from '../ResultItem';
import Pagination from '../Pagination';

const SearchResults = ({
   results, pagination, updatePagination, hasSearch, isSearching
}) => {
    if (isSearching) {
        return (
            <div className="cbdce-education-finder__search-results">
                <div className="cbdce-education-finder__search-results-msg">
                    <h4 className="cbdce-heading cbdce-heading--md">
                        Searching...
                    </h4>
                </div>
            </div>
        );
    }

    return (
        <div className="cbdce-education-finder__search-results">
            {(results.length !== 0) && (
                <>
                    <h5 className="cbdce-heading cbdce-heading--lg">
                        {pagination.totalCount} {pagination.totalCount === 1 ? 'result' : 'results'} found
                    </h5>
                    <ul className="cbdce-education-finder__search-results-list">
                        {results.map((member, idx) => (
                            <ResultItem member={member} key={idx}/>
                        ))}
                    </ul>
                    <Pagination
                        pagination={pagination}
                        updatePagination={updatePagination}
                    />
                </>
            )}
            {(!results.length && !hasSearch) && (
                <div className="cbdce-education-finder__search-results-msg">
                    <h4 className="cbdce-heading cbdce-heading--md">
                        Start your search by entering a location or searching by last name
                    </h4>
                </div>
            )}
            {(!results.length && hasSearch) && (
                <div className="cbdce-education-finder__search-results-msg">
                    <h4 className="cbdce-heading cbdce-heading--md">
                        No results were found. Please adjust your filters and try again.
                    </h4>
                </div>
            )}
        </div>
    );
};

export default SearchResults;
